import { properties } from "@repoflow/common/schema-fields";
import {
  orgId, 
  email,
  status,
  roles,
  domainId, 
  domain
} from "@common/schema/organization-users/fields";

export default [
  {
    id: "/Public/OrganizationUsers",
    type: "object",
    properties: {
      ...properties,
      orgId,
      email,
      status,
      roles,
      domainId, 
      domain
    },
  },
  {
    id: "/Public/OrganizationUsers/Invite",
    type: "object",
    properties: {
      email,
      roles
    },
    required: ["email", "roles"],
  },
  {
    id: "/Public/OrganizationUsers/Update",
    type: "object",
    properties: {
      status,
      roles
    },
  },
];
